module.exports = __webpack_public_path__ + "img/photo-3.5f5ffb1e.jpg";